export type Slide = {
  src: string;
  alt: string;
  caption: string;
  width: number;
  height: number;
};

export function SlideGallery({
  slides,
  tone = "ink",
}: {
  slides: readonly Slide[];
  tone?: "ink" | "paper";
}) {
  return (
    <div className={tone === "paper" ? "slide-gallery is-paper" : "slide-gallery"}>
      {slides.map((slide) => (
        <figure key={slide.src}>
          <a href={slide.src} target="_blank" rel="noreferrer">
            <img
              src={slide.src}
              alt={slide.alt}
              width={slide.width}
              height={slide.height}
            />
          </a>
          <figcaption>{slide.caption}</figcaption>
        </figure>
      ))}
    </div>
  );
}
